import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const socialNetworkDataClassName = DataClassName.SOCIAL_NETWORK
const socialNetworkEndpoint = PisaDataClassEndpoint.SOCIAL_NETWORK

export function pisaSocialNetworkDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(socialNetworkDataClassName, {
    title: socialNetworkDataClassName,
    restApi: createPisaRestApiConfig(socialNetworkEndpoint),
    attributes,
  })
}
